<template>
<div class="learingClass">
  <backHeader back-addr="/indexClass"></backHeader>
  <ul id="myScroll" v-infinite-scroll="loadMore" infinite-scroll-disabled="isLoadAll" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
    <li v-for="(item,index) in nes" style="margin-left:8px;margin-right:8px;margin-bottom:12px;padding-top:8px;border-top:1px solid #AAABB0;">
      <div style="display:flex;">
          <div style="flex:2;">
          <img :src="item.schoolImg" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
          <span style="font-size: .6rem;">{{item.schoolName}}</span>
        </div>

        <div style="flex:1;">
          <CollectElement v-bind:collect-data="item" v-bind:collect-state="item.collectionType" v-bind:collect-id="item.id" v-bind:collect-type="'neCollect'"></CollectElement>
        </div>
      </div>

      <div @click="goClassDetail(item.link)">

      
        <h4 style="margin-left:17px;margin-right:17px;margin-top:12px;margin-bottom:12px;font-size:18px;font-family: 'Helvetica Neue', Helvetica, STHeiTi, sans-serif;color: #456;font-weight:bold;">{{item.title}}</h4>
        <div style="display:flex;margin-left:17px;margin-right:17px;margin-top:8px;">
          <div v-for="image in item.images" style="text-align:center;flex:1;padding-right:2px;">
            <img :src="image" style="width:100%;height:100%;padding-left:2px;vertical-align:text-top;">
          </div>
        </div>

      </div>
      <!-- <div style="height:60px;"></div> -->
    </li>  
  </ul>
</div>
</template>
<script>
import openUrl from "./../utils/openUrl";
import backHeader from "./../components/back-header.vue";
import CollectElement from "@/components/collect";
// import IndexApi from '../api/learingInd.js'
import cfg from "./../utils/config";
import axios from "axios";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import { Toast } from "mint-ui";

export default {
  name: "learingClass",
  data() {
    return {
      isLoadAll: false,
      nes: null,
      pageRow: 6,
      pageNum: 1
    };
  },
  methods: {
    loadMore() {
      if (this.isLoadAll == true) {
        Toast({
          message: "已全部加载",
          position: "bottom",
          duration: 800
        });
        return;
      }
      this.pageNum++;

      axios
        .get(
          Addr.getGoNewAPIPrefix() +
            "ne/listNeByTypeId?typeId=" +
            this.$route.query.id +
            "&id=" +
            this.$store.state.mineStore.userId +
            "&pageNum=" +
            this.pageNum +
            "&pageRow=" +
            this.pageRow
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            if (res.data.returnData.list == null) {
              this.isLoadAll = true;
              Toast({
                message: "已全部加载",
                position: "bottom",
                duration: 800
              });
            } else {
              Toast({
                message: "已加载",
                position: "bottom",
                duration: 800
              });
              this.nes.push.apply(this.nes, res.data.returnData.list);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    goClassDetail(link) {
      //window.location.href = link;
      openUrl.open(link);
    },
    initNeData() {
      console.log("typeId is:");
      console.log(this.$route.params.typeId);
      axios
        .get(
          Addr.getGoNewAPIPrefix() +
            "ne/listNeByTypeId?typeId=" +
            this.$route.query.id +
            "&id=" +
            this.$store.state.mineStore.userId +
            "&pageNum=" +
            this.pageNum +
            "&pageRow=" +
            this.pageRow
        )
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            this.nes = res.data.returnData.list;
          }
          // //默认设置收藏状态
          // this.nes.forEach(function(value, index, array) {
          //     array[index].collectionType=false;
          //   });
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted: function() {
    this.initNeData();
    document.getElementById("myScroll").style.minHeight=(window.innerHeight+39)+"px";
  },
  components: {
    backHeader,
    CollectElement
  }
};
</script>

<style lang="scss"  scoped>
@import "../assets/baseScss";
</style>



// WEBPACK FOOTER //
// src/module-course/class.vue